import React from "react";
import { productCards, Tag } from "../../../productLinks";
import NewCategoryIcon from "../../../DesktopMenu/DesktopMenuDrawers/NewCategoryIcon";
import * as S from "../../styles";
import NutritionalSubMenu from "../NutritionalSubMenu";
import { Accordion } from "../../../../Accordion";

var byTag = function byTag(e) {
  return function (_ref) {
    var t = _ref.tags;
    return t.includes(e);
  };
};

export default function TopContent(_ref2) {
  var e = _ref2.topLevelLinks,
      t = _ref2.handleLinkClick,
      l = _ref2.renderLinkAs,
      a = _ref2.productCategories,
      o = _ref2.combinedProducts,
      n = _ref2.root;
  return React.createElement(React.Fragment, null, e.shopAll ? React.createElement(S.MenuItem, {
    key: "shop-all",
    href: e.shopAll.url,
    "data-testid": "mobile-shop-all-link",
    onClick: function onClick() {
      var l;
      return e && e.shopAll && e.shopAll.label && t(null === (l = null == e ? void 0 : e.shopAll) || void 0 === l ? void 0 : l.label);
    },
    as: l || void 0
  }, e.shopAll.label) : null, React.createElement(Accordion.Wrapper, null, a.map(function (e) {
    return function (e) {
      return e.slug === Tag.NutritionalHealth ? React.createElement(NutritionalSubMenu, {
        key: "mobile - " + e.slug,
        combinedProducts: o,
        category: e,
        handleLinkClick: t,
        cards: productCards(n).filter(function (t) {
          return t.tags.includes(e.slug);
        }),
        renderLinkAs: l
      }) : React.createElement(S.AccordionItem, {
        key: "mobile - " + e.slug
      }, React.createElement(S.AccordionHeading, {
        dataTestId: "mobile-shop-category-" + e.slug,
        onClick: function onClick() {
          return t(e.displayName);
        }
      }, e.slug === Tag.VitaminsAndSupplements ? React.createElement(S.AccordionHeadingContainer, null, React.createElement("span", null, e.displayName), React.createElement(NewCategoryIcon, {
        iconText: "NEW"
      })) : e.displayName), o.filter((a = e.slug, function (_ref3) {
        var e = _ref3.tags;
        return e.includes(a);
      })).map(function (_ref4, r) {
        var a = _ref4.label,
            o = _ref4.url,
            n = _ref4.slug;
        return React.createElement(S.AccordionChild, {
          key: "".concat(n, "-").concat(r)
        }, React.createElement(S.MenuItem, {
          "data-testid": n,
          onClick: function onClick() {
            return t("".concat(e.displayName, " - ").concat(a));
          },
          href: o,
          as: l || void 0
        }, a));
      }));
      var a;
    }(e);
  })));
}